<template>
  <transition name="fade">
    <div v-if="showOverlay" class="popup-container">
      <div class="popup">
        <div class="header">
          <span>如果写入剪贴板失败，请手动复制</span>
          <button @click="closePopup">关闭</button>
        </div>
        <div class="content">
          <textarea v-model="textContent" readonly style="font-size: 16px;"></textarea>
          <div class="copy-message">如果写入剪贴板失败，请手动复制</div>
        </div>
      </div>
      <div class="overlay"></div>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, ref } from 'vue';

defineOptions({name: 'TextToCopy'});

const props = defineProps({
  storeInfoText: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['close']);
const textContent = ref('');
const showOverlay = ref(false);

onMounted(() => {
  textContent.value = props.storeInfoText;
  showOverlay.value = true;
});

function closePopup () {
  emit('close');
  showOverlay.value = false;
}
</script>

<style scoped>

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-bg); /* 半透明黑色 */
  z-index: 9997; /* 比弹窗的z-index低一些 */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.popup {
  position: absolute;
  top: 33%;
  left: 3.2%;
  width: 92%;
  padding: 0.1rem; /* 添加内边距 */
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  background-color: var(--surface-bg);
  z-index: 10000;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-main);
}
.content {
  padding: 0.5rem;
}
textarea {
  width: calc(100% - 1rem); /* 宽度减去内边距 */
  height: 70px; /* 调整高度 */
  border: 1px solid var(--border-strong);
  background: var(--surface-soft);
  color: var(--text-normal);
  border-radius: 5px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  resize: none; /* 禁止拖动调整大小 */

}
.copy-message {
  text-align: right;
  color: var(--text-faint);
}
</style>
